import { v4 as uuid } from '@lukeed/uuid'
import Big from 'big.js'

import { apiPostJson } from '$lib/proxy/apiProxy'
import { debounced, SemaphoreKey } from '$lib/semaphores'
// import * as Sentry from '@sentry/sveltekit'
import type { Item } from '$lib/stores/item/types'
import type { ItemListItem, QuickItem } from '$lib/types/client_types'

export async function getItems(ItemsParams: any): Promise<ItemListItem[]> {
	const parameters = ItemsParams
	const jsonData = await apiPostJson('/items', {
		archived: parameters.archived,
		query: parameters.query,
		withName: parameters.withName,
		item_id: parameters.itemId,
		categories: parameters.categories,
		subcategories: parameters.subcategories
	})
	if (!jsonData || jsonData?.error) {
		return []
	}


	const items = jsonData.items.map((it: Item) => {
		return { ...it, cost: Big(it.cost), price: Big(it.price) }
	})

	return items
}


export async function getItemsList(options?: GetListItemsParams) {
	const jsonData = await apiPostJson('/items', {
		archived: options?.archived || [false, true],
		query: options?.query || '',
		withName: options?.withName === undefined ? true : options.withName,
		item_id: options?.item_id || ''
	})
	if (!jsonData || jsonData?.error) {
		return
	}


	return jsonData.items
}

export async function lookupItemsList(): Promise<QuickItem[]> {
	const jsonData = await apiPostJson('/lookup/items')
	if (!jsonData || jsonData?.error) {
		return []
	}

	if (jsonData.items)
		return jsonData.items

	return []
}

export const toItem = (item: Item): Item => {
	return {
		id: item.id,
		category_id: item.category_id,
		subcategory_id: item.subcategory_id,
		name: item.name,
		details: item.details,
		sku: item.sku,
		cost: Big(item.cost),
		price: Big(item.price),
		taxable: item.taxable,
		archived: item.archived
	}
}

type GetListItemsParams = {
	archived?: boolean[]
	query?: string
	withName?: boolean
	item_id?: string
}

const saveItemTax = (itemTax: Record<string, unknown>) => {
	const saveDebounce = async () => {
		const jsonData = await apiPostJson('/item_taxes/upsert', { ...itemTax })
		if (jsonData?.error) {
			throw `Could not save item: ${jsonData.error.message}`
		}
	}

	return saveDebounce
}

export const forceSetItemTax = async (updates: Record<string, unknown>) => {
	updates.id = updates.id || uuid()

	const fnSave = saveItemTax(updates)

	return await debounced(SemaphoreKey.ItemTax, fnSave, 0)
}

